import * as React from 'react';
import { createElement } from 'react';
import { Button } from '@alifd/next';
import './index.scss';
export class OadpEntityButtonCreate extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        console.log('OadpEntityButtonCreate render', this.props);
        let { type, size, disabled, text, label, style, onClick, __designMode, ...otherProps } = this.props;
        if (__designMode === 'design') {
            onClick = (e) => {
                console.log('design mode OadpEntityButtonCreate click');
            };
        }
        return (createElement(Button, Object.assign({ type: type, size: size, disabled: disabled, text: text, style: style, onClick: onClick }, otherProps), label));
    }
}
export default OadpEntityButtonCreate;
